export class UserRequestDto {
    createdUser: string;
   constructor(createdUser: string) 
   {
    this.createdUser=createdUser
   }
}